/*===================================
||
|| SiteHeaderContext
||
===================================*/
import React from "react";

import PropTypes from "prop-types";
// components
import SiteHeaderProvider from "./context/SiteHeaderProvider";
import PromoBanners from "./components/PromoBanners";
import ScrollToPinned from "./components/ScrollToPinned.js";
import Mobile from "./Mobile";
import TabletDesktop from "./TabletDesktop";

const SiteHeader = props => {
    return (
        <SiteHeaderProvider {...props}>
            <PromoBanners />
            <ScrollToPinned>
                <TabletDesktop />
                <Mobile />
            </ScrollToPinned>
        </SiteHeaderProvider>
    );
};

export default SiteHeader;

// prop-types
SiteHeader.propTypes = {
    isDarkMode: PropTypes.bool,
    currentPage: PropTypes.string
};
